import { Avatar, Box, ListItem, ListItemAvatar, ListItemButton, ListItemText, Typography } from "@mui/material";
import { SearchListItemLink } from "./SearchListItemLink";

export const ClientListItem = ({ data, onClick }: any) => {
  const { content } = data;

  if (!content) {
    return null;
  }

  const displayName = content.client_legal_name || content.label || "Unknown Client";
  const firstLetter = displayName?.charAt(0)?.toUpperCase() || "?";

  return (
    <ListItem sx={{ px: 0 }}>
      <ListItemButton component={SearchListItemLink} data={data} onClick={onClick}>
        <ListItemAvatar>
          <Avatar>{firstLetter}</Avatar>
        </ListItemAvatar>
        <ListItemText
          primary={displayName}
          secondary={
            <Box>
              {content.client_contact_name && (
                <Typography variant="caption" color="text.secondary">
                  {content.client_contact_name}
                </Typography>
              )}
              {content.aegle_id && (
                <Typography variant="caption" color="text.secondary" display="block">
                  ID: {content.aegle_id}
                </Typography>
              )}
            </Box>
          }
        />
      </ListItemButton>
    </ListItem>
  );
};
